// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs[data-v-719ecba4] .v-slide-group__next,.v-tabs[data-v-719ecba4] .v-slide-group__prev{min-width:36px}.v-tabs[data-v-719ecba4] .v-tab:not(.v-tab--active),.v-tabs[data-v-719ecba4] .v-tab:not(.v-tab--active) .v-icon{color:#fff!important}", ""]);
// Exports
module.exports = exports;
